import { ICustomerDetail } from 'pages/customer/detail/customerDetailsT1/type';
import { ImageResponseData } from 'pages/customer/detail/imageList/type';

export const types = {
  SET_SELECT_IMAGES: 'SET_SELECT_IMAGES' as const,
  SET_DRAWER_STATE: 'SET_DRAWER_STATE' as const,
};

export const setSelectImages = (data: ImageResponseData[], customerDetail:ICustomerDetail | null) => ({
  type: types.SET_SELECT_IMAGES,
  payload: {
    listImage: data,
    customerDetail,
  },
});

export const setDrawerStateRedux = (drawerState:boolean) => ({
  type: types.SET_DRAWER_STATE,
  payload: drawerState,
});
export type Actions = (
  | ReturnType<typeof setSelectImages>
  | ReturnType<typeof setDrawerStateRedux>
);
